export const appUniqueKey = (key) => {
    return (dispatch, getState) => {
        dispatch({ type: 'APP_UNIQUE_KEY', app_unique_key: key });
    }
};

export const asideRightOpen = (isOpen) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ASIDE_RIGHT_OPEN', aside_right_open: isOpen });
    }
};

export const asideCollapse = (toggle) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ASIDE_COLLAPSE', aside_collapse: toggle });
    }
};

export const routeHasChanged = (status) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ROUTE_HAS_CHANGED', route_has_changed: status });
    }
};